import type { SafeHtmlAttributes } from "@core/types/SafeHtmlAttributes";

import { SwatchItem } from "./components/SwatchItem/SwatchItem";

import styles from "./Swatch.module.scss";

export type SwatchItemConfig = {
  color: string;
  label: string;
  value: string;
  isOutOfStock?: boolean;
};

export type SwatchProps = {
  items: SwatchItemConfig[];
  value: string | undefined;
  onChange: (item: SwatchItemConfig) => void;
} & Omit<SafeHtmlAttributes<HTMLDivElement>, "children" | "onChange">;

export const Swatch = ({ items, value, onChange, ...rest }: SwatchProps) => (
  <div role="group" className={styles.swatch} {...rest}>
    {items.map((item) => (
      <SwatchItem
        key={item.value}
        color={item.color}
        label={item.label}
        isSelected={item.value === value}
        isOutOfStock={item.isOutOfStock}
        onClick={() => item.value !== value && onChange(item)}
      />
    ))}
  </div>
);
